<template>
  <section class="flex flex-col gap-4">
    <router-link :to="to" class="m-auto">
      <picture class="contents">
        <source srcset="/images/download/RN-Text-Logo-17b58-1024x459.webp" type="image/webp" />
        <img
        decoding="async"
        fetchpriority="high"
        width="250"
        height="250"
        src="/images/download/RN-Text-Logo-17b58-1024x459.png"
        />
      </picture>
    </router-link>
    <!-- Rendered as the site's download button (was red heading text). -->
    <router-link
      v-if="linkText"
      :to="to"
      class="m-auto text-center font-helvetica font-bold text-white text-[18px] md:text-[20px] bg-[#262626] border-4 border-[#FF0000] rounded-full px-8 py-4 hover:underline"
    >
      {{ linkText }}
    </router-link>
  </section>
</template>

<script>
export default {
  name: 'RallyLogoDownload',
  props: {
    linkText: {
      type: String,
    },
    // Download page to link to (/download, or /fr/download etc. on translated pages).
    to: { type: String, default: '/download' },
  },
};
</script>

<style scoped></style>
